<div class="header">
	<div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
		<div class="contentInner">
			<div class="pageTitle">
			<h1 class="headline">Everything you need to manage meetings</h1>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div class="contentInner">
	<div class="carousel">
    <div class="controls">
      <div class="controlButton" routerLink="/features" fragment="calendar" [class.active]="selectedItem==='calendarItem'"><div class="icon calendar" ></div>Calendar support</div>
      <div class="controlButton" routerLink="/features" fragment="display" [class.active]="selectedItem==='displayItem'"><div class="icon display" ></div>Meeting display</div>
      <div class="controlButton" routerLink="/features" fragment="booking" [class.active]="selectedItem==='bookingItem'"><div class="icon booking" ></div>Room booking</div>
      <div class="controlButton" routerLink="/features" fragment="branding" [class.active]="selectedItem==='brandingItem'"><div class="icon branding" ></div>Custom branding</div>
    </div>
		<div class="gallery">
			<div class="galleryItem" [ngClass]="{'selected': selectedItem === 'calendarItem'}">
        <div class="galleryContent">
          <div class="illustration calendar"></div>
          <div id="calendarD" class="description"  appGalleryScroll>
            <div class="indicator"></div>
            <h2 class="sectionHeader" id="calendar">Calendar support</h2>
            <p>
              Dash can connect directly to Microsoft 365 and Google Workspace, and can also read from your device's built in calendar to access a local Exchange server, CalDav, or any other calendar service supported by your device.
            </p>

            <p>
              Dash communicates with your calendar provider without the need for an intermediate service.&nbsp;&nbsp;This means that updates are reflected on your device as quickly
              as possible, and your calendar data never needs to be shared with us.
            </p>
          </div>
        </div>
			</div>
			<div class="galleryItem" [ngClass]="{'selected': selectedItem === 'displayItem'}">
        <div class="galleryContent">
          <div class="illustration display"></div>
          <div class="description" appGalleryScroll>
            <div class="indicator"></div>
            <h2 class="sectionHeader" id="display">Meeting display</h2>
            <p>
              The main room display is built to emphasise the important information you need to know, as well as giving
              you quick access to Dash's features.
            </p>
            <p>
              The information displayed on the screen can also be customized:
            </p>
            <ul>
              <li>Whether or not to show meeting titles</li>
              <li>The number of days ahead to show in the meeting schedule</li>
              <li>Controls for optional features such as room booking</li>
            </ul>
          </div>
        </div>
			</div>
			<div class="galleryItem" [ngClass]="{'selected': selectedItem === 'bookingItem'}">
        <div class="galleryContent">
          <div class="illustration booking"></div>
          <div class="description" appGalleryScroll>
            <div class="indicator"></div>
            <h2 class="sectionHeader" id="booking">Booking and check-in</h2>
            <h3>Book directly from the screen</h3>
            <p>
              Dash's optional room booking feature allows you to book the room directly from the screen.&nbsp;&nbsp;Just
              tap the amount of time you would like your booking to last (from 15 minutes to 2 hours).  Optionally,
              you can also book your meeting room in advance, straight from the display.
            </p>

            <h3>Automatically cancel abandoned meetings</h3>
            <p>
              You can also require users to check-in to meetings.  Meetings not checked-in to within ten minutes of them
              starting are ended, freeing up the room for other meetings.
            </p>

            <h3>Find free rooms</h3>
            <p>
              Dash shows you other meeting rooms in the building that are either free now or will be free in the next
              ten minutes.  You can then book a room directly from the screen, and head to the room knowing that your
              space is reserved.
            </p>
          </div>
        </div>
			</div>
			<div class="galleryItem" [ngClass]="{'selected': selectedItem === 'brandingItem'}">
        <div class="galleryContent">
          <div class="illustration branding"></div>
          <div class="description" appGalleryScroll>
            <div class="indicator"></div>
            <h2 class="sectionHeader" id="branding">Custom branding</h2>
            <p>
              Dash's display is highly customizable, allowing you showcase your company's brand.
            </p>
            <p>You can set a custom app background image displaying your company logo, and you can also
              customize the colors displayed on screen to match your branding.</p>
          </div>
			</div>
      </div>
		</div>
	</div>


</div>
